import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { fmtDate, fmtDateTime, monthLabel } from "@/lib/format";

export const ERP_TYPES = { sales: "Sales", outstanding: "Outstanding", expenses: "Expenses" };
export const DONE = ["Ready", "Failed", "Success", "Partial", "Cancelled"];
export const omanTime = (iso) => fmtDateTime(iso);

export function coverage(u) {
  if (u.type === "outstanding") return u.as_of ? `As of ${fmtDate(u.as_of)}` : "—";
  if (!u.range) return "—";
  if (u.type === "expenses") return `${monthLabel(u.range.from)} – ${monthLabel(u.range.to)} (${u.range.count} ${u.range.count === 1 ? "month" : "months"})`;
  return `${fmtDate(u.range.from)} – ${fmtDate(u.range.to)} (${u.range.count} ${u.range.count === 1 ? "date" : "dates"})`;
}

export const STATUS_CLS = {
  Success: "bg-green-50 text-green-700", Partial: "bg-amber-50 text-amber-700", Failed: "bg-red-50 text-red-700",
  Ready: "bg-teal-50 text-teal-700", Importing: "bg-slate-100 text-slate-700", Validating: "bg-slate-100 text-slate-700",
};

export function usePolledUpload(id) {
  const [job, setJob] = useState(null);
  const [nonce, setNonce] = useState(0);
  const timer = useRef(null);
  useEffect(() => {
    if (!id) { setJob(null); return undefined; }
    let alive = true;
    const tick = async () => {
      try {
        const { data } = await api.get(`/erp/uploads/${id}`);
        if (!alive) return;
        setJob(data);
        if (!DONE.includes(data.status)) timer.current = setTimeout(tick, 1000);
      } catch (_) {
        if (alive) timer.current = setTimeout(tick, 2000);
      }
    };
    tick();
    return () => { alive = false; clearTimeout(timer.current); };
  }, [id, nonce]);
  const restart = () => { setJob((j) => ({ ...j, status: "Importing", phase: "Starting" })); setNonce((x) => x + 1); };
  return [job, restart];
}
